import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'wonderbly-components/lib/Tooltip';

const FieldError = props => {
  return (
    <Tooltip className="error-tooltip" visible={!!props.visible} type="alert">
      {props.message}
    </Tooltip>
  );
};

FieldError.propTypes = {
  message: PropTypes.string,
  visible: PropTypes.string,
};

export default FieldError;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/Field/FieldError/FieldError.js